<div class="cell shrink grid-x align-middle align-justify">
    <h1 class="cell shrink _primary"[i18nKey]="'account.title'"></h1>
    <button class="cell shrink button _primary _iconRight" (click)="saveUser()">
        <span [i18nKey]="'common.action.save'"></span> <i class="fas fa-save"></i>
    </button>
</div>

<kiwi-spacer [size]="32"></kiwi-spacer>

<div class="cell auto grid-y" *ngIf="player">
    <div class="cell auto grid-x align-stretch">
        <div class="cell shrink accountDeco">
            <div class="accountDeco-img"></div>
        </div>
        <div class="cell auto grid-y">
            <div class="cell auto cell-block-y blockContent">
                <form>
                    <div class="grid-x align-middle align-justify accountForm-header">
                        <h2 class="cell shrink"[i18nKey]="'account.identity.title'"></h2>
                        <button class="cell shrink button _primary _small _iconLeft" (click)="onChangePassword()">
                            <i class="fas fa-lock"></i> {{'account.change.password' | translate}}
                        </button>
                    </div>
                    <div class="accountForm">
                        <label class="accountForm-item">
                            <span [i18nKey]="'account.identity.id'"></span>
                            <input type="text" [(ngModel)]="login" name="id" disabled="true"/>
                        </label>
                        <label class="accountForm-item">
                            <span [i18nKey]="'account.identity.first.name'"></span>
                            <input type="text" [(ngModel)]="player.person.firstName" name="firstName"/>
                        </label>
                        <label class="accountForm-item">
                            <span [i18nKey]="'account.identity.last.name'"></span>
                            <input type="text" [(ngModel)]="player.person.lastName" name="lastName"/>
                        </label>
                    </div>
                </form>
                <kiwi-spacer [size]="24"></kiwi-spacer>
                <form>
                    <h2 [i18nKey]="'account.contact.title'"></h2>
                    <div class="accountForm">
                        <label class="accountForm-item">
                            <span [i18nKey]="'account.contact.first.mail'"></span>
                            <input type="text" [(ngModel)]="player.person.contact.mail" name="mail"/>
                        </label>
                        <label class="accountForm-item">
                            <span [i18nKey]="'account.contact.second.mail'"></span>
                            <input type="text" [(ngModel)]="player.person.contact.mailOptional" name="mailOptional"/>
                        </label>
                        <label class="accountForm-item">
                            <span [i18nKey]="'account.contact.mobile.phone'"></span>
                            <input type="text" [(ngModel)]="player.person.contact.mobilePhone" name="mobilePhone"/>
                        </label>
                        <label class="accountForm-item">
                            <span [i18nKey]="'account.contact.phone'"></span>
                            <input type="text" [(ngModel)]="player.person.contact.fixPhone" name="fixPhone"/>
                        </label>
                    </div>
                </form>
                <kiwi-spacer [size]="24"></kiwi-spacer>
                <form>
                    <h2 [i18nKey]="'account.address.title'"></h2>
                    <div class="accountForm">
                        <label class="accountForm-item">
                            <span [i18nKey]="'account.address.address'"></span>
                            <input type="text" [(ngModel)]="player.person.contact.address.line1" name="address"/>
                        </label>
                        <label class="accountForm-item">
                            <span [i18nKey]="'account.address.address.complete'"></span>
                            <input type="text" [(ngModel)]="player.person.contact.address.line2" name="addressComplete"/>
                        </label>
                        <label class="accountForm-item">
                            <span [i18nKey]="'account.address.postal.code'"></span>
                            <input type="text" [(ngModel)]="player.person.contact.address.postalCode" name="postalCode"/>
                        </label>
                        <label class="accountForm-item">
                            <span [i18nKey]="'account.address.city'"></span>
                            <input type="text" [(ngModel)]="player.person.contact.address.city" name="city"/>
                        </label>
                        <label class="accountForm-item">
                            <span [i18nKey]="'account.address.country'"></span>
                            <input type="text" [(ngModel)]="player.person.contact.address.country" name="country"/>
                        </label>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
